import { gql } from '@apollo/client'

export const PRICE_TYPE_FRAGMENT = gql`
  fragment PriceType on PriceType {
    id
    unitAmount
    currency
    recurring
    type
  }
`
